
import { Component, Vue, Prop } from 'vue-property-decorator';
import { OrdineMTMTestata} from '@/models';
import ItemListOrdineMTM from "./ItemListOrdineMTM.vue";

@Component({
    components: { ItemListOrdineMTM }
})
export default class OrdiniList extends Vue {
    @Prop() private ordini!: OrdineMTMTestata[];    
}
